import React from 'react';
import { Footer } from '../components/HomePage';
import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import PostCircle from '../components/PostCircle/PostCircle';

function PostCirclePage() {
  return (
    <>
      <HowItWorksHeader />
      <PostCircle />
      <Footer />
    </>
  );
}

export default PostCirclePage;